import { isMobile } from 'react-device-detect';

const clientPlatform = isMobile ? 'mobile_web' : 'web';

export default clientPlatform;
